import '../../resources/css/settings/SettingsAccountRole.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { /*Row, Col, Nav,*/ Tab } from 'react-bootstrap';
import AccountSettingsList from './AccountSettingsList';
import { openModalAlert } from '../../actions';
// import RoleSettingsList from './RoleSettingsList';

class SettingsAccountRole extends Component {

  state = {
    selectKey: 'account',
  }

  changeNav = (key) => {
    this.setState({
      selectKey: key
    });
  }

  handleExportData = async () => {
    const { authToken, openModalAlert } = this.props;
    
    try {
      const url = window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/exportcsv';
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `${authToken}`,
          'Content-Type': 'text/csv'
        }
      });
  
      
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('text/csv')) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        
        const contentDisposition = response.headers.get('content-disposition');
        const fileName = contentDisposition?.split('filename=')[1]?.replace(/"/g, '') || 'accounts.csv';
        
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        
        return;
      } else {
        const text = await response.text();
        const jsonResponse = JSON.parse(text);
        openModalAlert(jsonResponse.responseMsg);
      }     
    } catch (error) {
      openModalAlert(error.message);
    }
  };

  render() {
    const { pageSize, tabulatorDivHeight } = this.props;
    const tabHeight = 62, accRoleHeaderHeight = 24, listPaddingHeight = 21, listMarginHeight = 50;
    const listHeight = tabulatorDivHeight-tabHeight-accRoleHeaderHeight-listPaddingHeight-listMarginHeight;
    const { selectKey } = this.state;    

    return (
      <div className='setting-account-role'>
        <div className='area-tip'>
          <div className='header-container'>
            <div className='left-content'>
              <div className='area-title'>Accounts</div>
              <div className='tip-content'>It allows you to manage accounts.</div>
            </div>
            <button
              id="setting-account-role-export"
              onClick={this.handleExportData} 
              className='export-button'
              title="Export account data"
            >
              Export Data
            </button>
          </div>
        </div>
        <div className='area-tabs'>
          <Tab.Container defaultActiveKey="account">
              {/*<Nav variant="pills">*/}
              {/*    <div className='tabs-item'>*/}
              {/*        <Row>*/}
              {/*            <Col sm={6} >*/}
              {/*                <Nav.Item>*/}
              {/*                    <Nav.Link eventKey="account" onClick={() => this.changeNav('account')}>*/}
              {/*                        <div className='tab'>Account</div>*/}
              {/*                    </Nav.Link>*/}
              {/*                </Nav.Item>*/}
              {/*            </Col>*/}
              {/*            <Col sm={6}>*/}
              {/*                <Nav.Item>*/}
              {/*                    <Nav.Link eventKey="role" onClick={() => this.changeNav('role')}>*/}
              {/*                        <div className='tab'>Role</div>*/}
              {/*                    </Nav.Link>*/}
              {/*                </Nav.Item>*/}
              {/*            </Col>*/}
              {/*            /!* <Col sm={4}>*/}
              {/*              &nbsp;*/}
              {/*            </Col> *!/*/}
              {/*        </Row>*/}
              {/*    </div>*/}
              {/*</Nav>*/}
              <Tab.Content>
                  <Tab.Pane eventKey="account" >
                      <div className="area-tab-config">
                        <AccountSettingsList pageSize={pageSize} tabulatorDivHeight={ listHeight } selectKey={selectKey}></AccountSettingsList>
                      </div>
                  </Tab.Pane>
                  {/*<Tab.Pane eventKey="role">*/}
                  {/*    <div className="area-tab-config">*/}
                  {/*      <RoleSettingsList pageSize={pageSize} tabulatorDivHeight={ listHeight } selectKey={selectKey}></RoleSettingsList>*/}
                  {/*    </div>*/}
                  {/*</Tab.Pane>*/}
              </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    authToken: state.loginReducers.authToken,
  }
}

export default withRouter(connect(
  mapStateToProps,
  {openModalAlert}
)(SettingsAccountRole))
